
import React, { useState } from 'react';
import { Separator } from '@/components/ui/separator';
import { Button } from '@/components/ui/button';
import { Plus, Eye, EyeOff, Webhook } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import WebhookItem from '../components/WebhookItem';

interface WebhooksTabProps {
  editing: boolean;
}

const WebhooksTab: React.FC<WebhooksTabProps> & { Icon: typeof Webhook } = ({ editing }) => {
  const [showSecret, setShowSecret] = useState(false);
  
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between space-x-2">
        <div className="space-y-0.5">
          <h3 className="font-medium text-lg">Webhook Configuration</h3>
          <p className="text-muted-foreground text-sm">
            Setup webhooks for third-party integrations
          </p>
        </div>
        {editing && (
          <Button variant="outline" size="sm" className="gap-1">
            <Plus className="h-4 w-4" />
            Add Webhook
          </Button>
        )}
      </div>
      
      <Separator />
      
      <div className="space-y-4">
        <WebhookItem 
          name="Device Status Webhook"
          description="Triggers when device status changes"
          url="https://example.com/webhooks/device-status"
          secret="whsec_sample_secret_key_123"
          active={true}
          editing={editing}
          showSecret={showSecret}
          onToggleSecret={() => setShowSecret(!showSecret)}
        />
        
        {!editing && (
          <div className="border rounded-md border-dashed p-6 flex items-center justify-center">
            <Button variant="outline" disabled={!editing} className="gap-1">
              <Plus className="h-4 w-4" />
              Add Webhook Endpoint
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

WebhooksTab.Icon = Webhook;

export default WebhooksTab;
